// Customer payment is separate from platform transfers and bank payouts.
export function customerPaymentStatus(row) {
  const refund = String(row?.refund_status || '').toLowerCase();
  if (refund === 'succeeded') return 'Refunded';
  if (refund === 'partial') return 'Partially refunded';
  if (['pending', 'processing'].includes(refund)) return 'Refund processing';
  if (refund === 'failed') return 'Refund failed';
  return [true, 'true', 'paid', 'succeeded'].includes(row?.payment_status) ? 'Paid' : 'Pending';
}
